import styled from "styled-components";
import DbFileList from "../../view/contents/db/db.file.list";
import type { DeviceItem } from "../../view/contents/backup/backup.device.list";
import ModalCenterLayout from "../modal/modal.center.layout";

interface Props {
  device: DeviceItem;
  onClose: () => void;
}

const DbBackupModal = ({ device, onClose }: Props) => (
  <ModalCenterLayout isVisible closedHandler={onClose} size="l">
    <Contents role="dialog" aria-modal="true" aria-labelledby="db-backup-title">
      <div className="db-modal-header">
        <h3 id="db-backup-title">DB 백업 파일 목록</h3>
        <button type="button" aria-label="DB 백업 목록 닫기" onClick={onClose}>
          ×
        </button>
      </div>
      {/* <div className="db-device-name">
        {device.pcName + `(` + device.deviceId + `)`}
      </div> */}
      <DbFileList
        context={{
          userId: device.userId,
          deviceId: device.deviceId,
          userAccount: device.userAccount,
          pcName: device.pcName,
        }}
      />
    </Contents>
  </ModalCenterLayout>
);

const Contents = styled.div`
  max-height: 85vh;
  overflow: auto;
  background: white;
  .db-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.6rem 2rem;
    background: #333333;
    color: white;
    h3 {
      font-size: 1.8rem;
    }
    button {
      border: 0;
      background: none;
      color: white;
      font-size: 2.4rem;
      cursor: pointer;
    }
  }
  .db-device-name {
    padding: 1.6rem 2rem 0;
    font-size: 1.4rem;
  }
  .file-list-container {
    height: auto;
    padding: 2rem;
  }
`;

export default DbBackupModal;
